export default __webpack_public_path__ + "static/media/Reviews.4806160a.png";